import { i18n } from "@lingui/core";
import { rankings } from 'match-sorter';
import useSiteConfig from '@bottlebooks/gatsby-theme-event/src/components/useSiteConfig'; // TODO generate this automatically from the fragment.

export default function useExhibitorFilters() {
  var _useSiteConfig = useSiteConfig(),
      showDistributionDetails = _useSiteConfig.showDistributionDetails;

  return {
    aggregations: Object.assign({
      landessieger: {
        title:
        /*i18n*/
        {
          id: 'Landessieger'
        },
        multiSelect: true,
        conjunction: false,
        sort: 'term',
        order: 'desc',
        get: function get(exhibitor) {
          var _exhibitor$medaillen, _exhibitor$medaillen2, _exhibitor$medaillen3;

          return ((_exhibitor$medaillen = exhibitor.medaillen) === null || _exhibitor$medaillen === void 0 ? void 0 : _exhibitor$medaillen.length) === 1 ? ' Landessieger' : (_exhibitor$medaillen2 = exhibitor.medaillen) !== null && _exhibitor$medaillen2 !== void 0 && _exhibitor$medaillen2.length ? ((_exhibitor$medaillen3 = exhibitor.medaillen) === null || _exhibitor$medaillen3 === void 0 ? void 0 : _exhibitor$medaillen3.length) + "-facher Landessieger" : undefined;
        }
      },
      event: {
        title:
        /*i18n*/
        {
          id: 'Events'
        },
        // multiSelect: false, // TODO Implement
        size: 20,
        get: function get(exhibitor) {
          var _exhibitor$event;

          return (_exhibitor$event = exhibitor.event) === null || _exhibitor$event === void 0 ? void 0 : _exhibitor$event.name;
        }
      },
      highlights: {
        title:
        /*i18n*/
        {
          id: 'Highlights'
        },
        // multiSelect: false, // TODO Implement
        size: 20,
        get: 'offeringTypes',
        translations: {
          videos:
          /*i18n*/
          {
            id: 'Videos'
          },
          onlineShop:
          /*i18n*/
          {
            id: 'Online shop'
          },
          imageGallery:
          /*i18n*/
          {
            id: 'Image gallery'
          }
        }
      },
      regionHierarchy: {
        title:
        /*i18n*/
        {
          id: 'Winegrowing regions'
        },
        conjunction: false,
        // multiSelect: false,
        size: 100,
        get: function get(exhibitor) {
          var _exhibitor$regionSumm;

          return (exhibitor === null || exhibitor === void 0 ? void 0 : (_exhibitor$regionSumm = exhibitor.regionSummary) === null || _exhibitor$regionSumm === void 0 ? void 0 : _exhibitor$regionSumm.filter(Boolean)) || [];
        } // Excludes nulls

      },
      priceRanges: {
        title:
        /*i18n*/
        {
          id: 'Price ranges'
        },
        conjunction: false,
        // multiSelect: false,
        size: 100,
        get: function get(exhibitor) {
          return (exhibitor === null || exhibitor === void 0 ? void 0 : exhibitor.priceRangeSummary) || [];
        } // Excludes nulls

      },
      primaryGrapeVariety: {
        title:
        /*i18n*/
        {
          id: 'Primary grape varieties'
        },
        conjunction: false,
        size: 300,
        get: function get(exhibitor) {
          var _exhibitor$primaryVar;

          return (exhibitor === null || exhibitor === void 0 ? void 0 : (_exhibitor$primaryVar = exhibitor.primaryVarietySummary) === null || _exhibitor$primaryVar === void 0 ? void 0 : _exhibitor$primaryVar.filter(Boolean)) || [];
        }
      },
      countryName: {
        title:
        /*i18n*/
        {
          id: 'Countries'
        },
        size: 100,
        conjunction: false,
        // Remove null values
        get: function get(exhibitor) {
          return exhibitor.countryName || [];
        }
      }
    }, getDistributionFilters(showDistributionDetails)),
    sortings: {
      byStandName: {
        title:
        /*i18n*/
        {
          id: 'Table number'
        },
        field: [sortBy.standName, 'profile.sortName', 'name'],
        order: 'asc'
      },
      // byDataCompleteness: {
      //   title: defineMessage({ message: 'By data completeness' }),
      //   field: [
      //     sortBy.standName,
      //     sortBy.dataCompleteness,
      //     'profile.sortName',
      //     'name',
      //   ],
      //   order: 'asc',
      // },
      byExhibitorName: {
        title:
        /*i18n*/
        {
          id: 'Exhibitor name'
        },
        field: ['profile.sortName', 'name'],
        order: 'asc'
      }
    },
    search: {
      threshold: rankings.WORD_STARTS_WITH,
      keys: [{
        key: 'name',
        threshold: rankings.CONTAINS
      }, function (exhibitor) {
        return ((exhibitor.countryName || '') + " " + (exhibitor.region || '') + " " + (exhibitor.city || '')).trim();
      }, function (exhibitor) {
        var _exhibitor$stand, _exhibitor$stand$name;

        return (exhibitor === null || exhibitor === void 0 ? void 0 : (_exhibitor$stand = exhibitor.stand) === null || _exhibitor$stand === void 0 ? void 0 : (_exhibitor$stand$name = _exhibitor$stand.name) === null || _exhibitor$stand$name === void 0 ? void 0 : _exhibitor$stand$name.replace(/[()]/g, '')) || '';
      }]
    }
  };
}

function getDistributionFilters(showDistributionDetails) {
  switch (showDistributionDetails) {
    case 'inMarket':
      return {
        isSeekingDistribution: isSeekingDistribution
      };

    case 'global':
      return {
        distributionInCountries: distributionInCountries,
        seekingDistributionInCountries: seekingDistributionInCountries
      };

    case 'all':
      return {
        isSeekingDistribution: isSeekingDistribution,
        distributionInCountries: distributionInCountries,
        seekingDistributionInCountries: seekingDistributionInCountries
      };

    case 'none':
    default:
      return {};
  }
}

var distributionInCountries = {
  title:
  /*i18n*/
  {
    id: 'Distribution in countries'
  },
  size: 200,
  conjunction: true,
  multiSelect: true,
  get: function get(exhibitor) {
    var _exhibitor$profile, _exhibitor$profile$di;

    return ((_exhibitor$profile = exhibitor.profile) === null || _exhibitor$profile === void 0 ? void 0 : (_exhibitor$profile$di = _exhibitor$profile.distributionInCountries) === null || _exhibitor$profile$di === void 0 ? void 0 : _exhibitor$profile$di.filter(Boolean)) || [];
  }
};
var seekingDistributionInCountries = {
  title:
  /*i18n*/
  {
    id: 'Seeking distribution'
  },
  size: 200,
  conjunction: true,
  multiSelect: true,
  get: function get(exhibitor) {
    var _exhibitor$profile2, _exhibitor$profile2$s;

    return ((_exhibitor$profile2 = exhibitor.profile) === null || _exhibitor$profile2 === void 0 ? void 0 : (_exhibitor$profile2$s = _exhibitor$profile2.seekingDistributionInCountries) === null || _exhibitor$profile2$s === void 0 ? void 0 : _exhibitor$profile2$s.filter(Boolean)) || [];
  }
};
var isSeekingDistribution = {
  title:
  /*i18n*/
  {
    id: 'Distribution in Market'
  },
  size: 100,
  conjunction: false,
  get: function get(exhibitor) {
    return String(exhibitor.isSeekingDistribution || false);
  },
  translations: {
    true:
    /*i18n*/
    {
      id: 'Seeking Distribution'
    },
    false:
    /*i18n*/
    {
      id: 'Has Distribution'
    }
  }
};
var completeness = {
  ORGANIZER_REVIEWED: 1,
  STEP_COMPLETED: 2,
  STEP_PAYMENT: 2,
  STEP_REVIEW: 3
}; // Sort helper functions

var sortBy = {
  standName: function standName(exhibitor) {
    var _exhibitor$stand2, _exhibitor$stand2$nam;

    return (exhibitor === null || exhibitor === void 0 ? void 0 : (_exhibitor$stand2 = exhibitor.stand) === null || _exhibitor$stand2 === void 0 ? void 0 : (_exhibitor$stand2$nam = _exhibitor$stand2.name) === null || _exhibitor$stand2$nam === void 0 ? void 0 : _exhibitor$stand2$nam.split(/[\s,-]+/).map(function (segment) {
      return segment === 'Tisch' ? undefined : Number(segment) ? segment.padStart(3, '0') : segment;
    }).filter(Boolean)) || [];
  },
  dataCompleteness: function dataCompleteness(exhibitor) {
    var _exhibitor$registered;

    return completeness[exhibitor === null || exhibitor === void 0 ? void 0 : exhibitor.registrationStatus] - ((exhibitor === null || exhibitor === void 0 ? void 0 : (_exhibitor$registered = exhibitor.registeredProducts) === null || _exhibitor$registered === void 0 ? void 0 : _exhibitor$registered.totalCount) > 0 ? 1 : 0);
  }
};
var fragment = "1148505633";